<template>
  <div id="app" class="min-h-screen bg-parchment-50">
    <RouterView />
    
    <!-- Persistent Audio Recovery Notification -->
    <PersistentAudioNotification />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useProjectStore } from '@/stores/project' 
import { useConfigStore } from '@/stores/config'
import PersistentAudioNotification from '@/components/notifications/PersistentAudioNotification.vue'

const authStore = useAuthStore()
const projectStore = useProjectStore()
const configStore = useConfigStore()

onMounted(async () => {
  // Initialize application configuration first (doesn't require auth)
  await configStore.loadConfig()
  
  // Auth initialization is handled by router guard to prevent duplication
  // Projects are loaded after auth is confirmed by router guard
  
  // Load user projects if authenticated (with duplicate call protection in store)
  if (authStore.isAuthenticated) {
    await projectStore.loadUserProjects()
  }
})
</script>